import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { colors, fontSizes } from 'theme'
import { Label, IonIcon, SimpleIcon, Modal } from 'controls'
import { ImageGallery } from 'components'
import Map, { Pin } from 'components/Map'
import { getThumbnail, getCroppedImage } from 'services/utils'
import { image } from 'services'
import { formatCurrency } from 'services/number'

import { gallery, iconNav, breadcrumbs } from './styles'

const DEFAULT_URL = image('/property/defaultproperty.jpg')

class Blueprints extends Component {
  renderNav = type => (onClick, disabled) => {
    return (
      <div className="background" style={{ [type]: '1rem' }} onClick={onClick}>
        <IonIcon icon={`md-arrow-drop${type}`} disabled={disabled} />
        <style jsx>{iconNav}</style>
      </div>
    )
  }

  render() {
    const {
      property: { imagesJson }
    } = this.props
    const blueprints = imagesJson.filter(blueprint => blueprint.imageType === 'BLUEPRINT')
    return (
      <section className="container">
        <ImageGallery
          showThumbnails={false}
          showPlayButton={false}
          items={
            blueprints.length > 0
              ? blueprints.map(blueprint => ({
                  original: getThumbnail({file: blueprint.url, sizeName: 'fullScreen', format: 'jpg'}),
                  thumbnail: getCroppedImage({file: blueprint.url, format: 'jpg'}),
                  imageSet: [
                    {
                      srcSet: getThumbnail({file: blueprint.url, sizeName: 'fullScreen', format: 'webp'}),
                      type: 'image/webp'
                    }
                  ],

                }))
              : [
                  {
                    original: DEFAULT_URL,
                    thumbnail: DEFAULT_URL,
                  }
                ]
          }
          renderLeftNav={this.renderNav('left')}
          renderRightNav={this.renderNav('right')}
        />
        <style jsx>{gallery}</style>
      </section>
    )
  }
}
export default Blueprints
